import { FC } from 'react';
import AlertDialog from 'components/AlertDialog';
import Typography from '@mui/material/Typography';
import { Disclosure } from 'further-ui/hooks';

type Props = {
  disclosure: Disclosure;
  onConfirm: () => void;
};

const SubscriptionDateChangeWarningModal: FC<Props> = ({
  disclosure,
  onConfirm,
}) => (
  <AlertDialog
    open={disclosure.isOpen}
    title="Subscription date change"
    content={
      <Typography>
        If you change the subscription date, it will change the date that fees
        are charged and accrued from where fees have not yet been exported. If a
        fee has been exported, its date will not change. Do you wish to proceed?
      </Typography>
    }
    size="sm"
    onConfirm={() => {
      onConfirm();
      disclosure.onClose();
    }}
    onClose={disclosure.onClose}
    onCancel={disclosure.onClose}
    btnLabels={{
      cancel: 'Go back',
      confirm: 'Submit',
    }}
    cancelBtnProps={{
      color: 'primary',
    }}
  />
);

export default SubscriptionDateChangeWarningModal;
